import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  type: 'access-financials-mcp',
  name: 'Access Financials MCP',
  category: 'access-integrations',
  description: 'Connect to Access Financials MCP server for AI agent tool discovery and execution',
  icon: 'Plug',
  color: 'green',
  version: '1.0.0',
  comingSoon: false,
  defaults: {
    name: 'Access Financials MCP',
    color: '#22c55e', // green
  },
  inputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Input',
      required: true,
    },
  ],
  outputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Output',
    },
  ],
  toolCapable: {
    enabled: true,
    name: 'access_financials_mcp',
    description: 'Connect to Access Financials MCP server to discover and execute financial tools dynamically',
    allowManualDescription: true,
    parameters: {
      operation: {
        toolParamName: 'operation',
        description: 'The MCP operation to perform: listTools to discover available tools, or executeTool to run a specific tool',
        required: true,
        type: 'string',
      },
      toolName: {
        toolParamName: 'toolName',
        description: 'The name of the MCP tool to execute (required for executeTool operation)',
        required: false,
        type: 'string',
      },
      arguments: {
        toolParamName: 'arguments',
        description: 'JSON arguments to pass to the MCP tool (for executeTool operation)',
        required: false,
        type: 'object',
      },
    },
  },
};

export default definition;
